<app-c2c-order-details [data]="senderDetails"></app-c2c-order-details>